import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { AppConfigsActionDispatchTypes } from "../constants/AppConfigs";
import { ApplicationState } from "../redux/ApplicationState";
import { AppConfigsDispatchTypes } from "../models/dispatchTypes/AppConfigs";
import { GetAppConfigs } from "../services/AppConfigs";
import { configs, configUrl } from "../constants/Config";

export const getConfigs: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AppConfigsDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AppConfigsActionDispatchTypes.APP_CONFIG_INVOKE,
    });
    const response = await GetAppConfigs(configUrl);
     if (response && response.status) {
          switch (response.status) {
            case 422:
            case 400:
            case 404:
            case 500:
              dispatch({
                type: AppConfigsActionDispatchTypes.APP_CONFIG_ERROR,
              });
              break;
            case 200:
              dispatch({
                response: {
                  ...configs,
                  ...response.data,
                },
                type: AppConfigsActionDispatchTypes.APP_CONFIG_SUCCESS,
              });
              break;
            default:
              break;
          }
        }
  };
};
